import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "additional-section" }
const _hoisted_2 = { class: "sidebar-container" }
const _hoisted_3 = { class: "additional-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("aside", {
          key: 0,
          class: "sidebar-container",
          style: _normalizeStyle({ width: _ctx.isShort ? '60px' : '300px' })
        }, [
          _createElementVNode("section", {
            class: "main-section",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setBurgerMenu && _ctx.setBurgerMenu(...args)))
          }, [
            _renderSlot(_ctx.$slots, "main", { isShort: _ctx.isShort }, undefined, true)
          ]),
          _createElementVNode("section", _hoisted_1, [
            _renderSlot(_ctx.$slots, "additional", {
              isShort: _ctx.isShort,
              toggle: _ctx.toggle
            }, undefined, true)
          ])
        ], 4))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.isMobile && _ctx.isBurgerMenuOpen && _ctx.landing)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "mobile-scrim landing",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setBurgerMenu && _ctx.setBurgerMenu(...args)))
          }))
        : _createCommentVNode("", true),
      (_ctx.isMobile && _ctx.isBurgerMenuOpen)
        ? (_openBlock(), _createElementBlock("aside", {
            key: 1,
            class: _normalizeClass(["mobile-view", { landing: _ctx.landing }]),
            style: _normalizeStyle({ width: _ctx.isShort ? '60px' : '220px' })
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("section", {
                class: "main-section",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setBurgerMenu && _ctx.setBurgerMenu(...args)))
              }, [
                _renderSlot(_ctx.$slots, "main", { isShort: _ctx.isShort }, undefined, true)
              ]),
              _createElementVNode("section", _hoisted_3, [
                _renderSlot(_ctx.$slots, "additional", {
                  isShort: _ctx.isShort,
                  toggle: _ctx.toggle
                }, undefined, true)
              ])
            ])
          ], 6))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}